/* eslint-disable @typescript-eslint/ban-ts-comment */
import React, { useState, useEffect } from 'react'
import { Input } from '../../components/Input/Input'
import {
  Flex,
  Button,
  BlackCircle,
  AddButton,
  Separator,
  CursorPointer,
  WhiteBackground,
  PageWrapper,
  H1WithBack,
  PageFooter,
  Duplicate,
} from '../../styling/GlobalStyles'
import RemoveCircle from '../../assets/icons/RemoveCircle'
import { AddCircle } from '../../assets/icons/AddCircle'
import { useDispatch, useSelector } from 'react-redux'
import {
  clearOperationGroup,
  getSingleOperationGroup,
  updateOperationGroup,
} from '../../features/operationGroups/operationGroupsSlice'
import { useNavigate, useParams } from 'react-router-dom'
import { v4 } from 'uuid'
import { toast } from 'react-toastify'
import { NavBar } from '../../components/NavBar/NavBar'
import { HonestSelectInput } from '../../components/HonestSelect/HonestSelectInput'
import { AppDispatch, RootState } from 'store'
import { getParameters } from 'features/parameters/parametersSlice'
import { IParameters } from 'types/parameters.interface'
import { IOperationParameter, IOperation } from 'types/operations.interface'
import { ISelectValue } from 'constants/globalTypes'
import { CancelBtn } from 'components/Button/CancelBtn'
import { DuplicateIcon } from 'assets/icons/DuplicateIcon'
import useFocusFirstInput from 'utils/useFocusFirstInput'

export const EditOperationGroup = () => {
  const dispatch = useDispatch<AppDispatch>()
  const [name, setName] = useState('')
  const [description, setDescription] = useState('')
  const [nameInvalid, setNameInvalid] = useState(false)
  const [descInvalid, setDescInvalid] = useState(false)
  const [operations, setOperations] = useState<any>([
    { id: 1, name: '', parameters: ['min'] },
  ])
  const { id } = useParams()
  const { singleOperationGroup } = useSelector((store: RootState) => store.operationGroups)
  const fetchedParameters = useSelector((state: RootState) => state.parameters.parameters)
  const navigate = useNavigate()

  useFocusFirstInput()

  useEffect(() => {
    dispatch(getSingleOperationGroup(id))
    dispatch(getParameters())
    return () => {
      dispatch(clearOperationGroup())
    }
  }, [])

  useEffect(() => {
    if (singleOperationGroup) {
      setName(singleOperationGroup.name)
      setDescription(singleOperationGroup.description)

      const ar = []
      // @ts-ignore
      if (Array.isArray(singleOperationGroup.operations)) {
        // @ts-ignore
        for (const a of singleOperationGroup.operations) {
          const b = structuredClone(a)
          if (!b.id) {
            b.id = parseInt(v4(), 10) // mozda error
          }
          ar.push(b)
        }
      }
      setOperations(ar)
    }
  }, [singleOperationGroup])

  const handleSubmit = async () => {
    if (
      name.length < 1 ||
      description.length < 1 ||
      operations.some((item: IOperation) => item.invalid === true || !item.name)
    ) {
      toast.error('Fields must not be empty')
    } else if (
      operations.some((item: IOperation) =>
        item.parameters.some((p: IOperationParameter) => !p.parameterId || !p.unitId),
      )
    ) {
      console.log(operations)
      toast.error('All operation parameters and units must be filled')
    } else {
      const resp = await dispatch(
        updateOperationGroup({
          id: Number(id),
          operations: operations.map((type: IOperation) => ({
            id: typeof type.id == 'string' ? null : type.id,
            name: type.name,
            parameters: type.parameters.map((param) => {
              const ob = {
                parameterId: param.parameterId,
                id: param.id,
                unitId: param.unitId,
              }
              if (param.newField) {
                delete ob.id
              }
              return ob
            }),
          })),
          name,
          description,
        }),
      )
      if (resp.meta.requestStatus === 'fulfilled') {
        navigate(-1)
      }
    }
  }

  const checkTypeValid = (e: React.ChangeEvent<HTMLInputElement>) => {
    setOperations((prev: IOperation[]) => {
      const newAr = [...prev]
      const objIndex = newAr.findIndex((obj) => obj.id == e.target.name)
      newAr[objIndex].invalid = e.target.value.length < 1
      return newAr
    })
  }

  const handleRemoveParameters = (itemId: number | string, paramId: number | string) => {
    const newAr = [...operations]
    const objIndex = newAr.findIndex((obj) => obj.id === itemId)
    newAr[objIndex].parameters = newAr[objIndex].parameters.filter(
      (parameter: IOperationParameter) => parameter.id !== paramId,
    )

    setOperations(newAr)
  }

  const inputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setOperations((prev: IOperation[]) => {
      const newAr = [...prev]
      const objIndex = newAr.findIndex((obj) => obj.id == e.target.name)
      if (objIndex > -1) {
        newAr[objIndex].name = e.target.value
      } else {
        newAr.push({
          id: v4(),
          name: e.target.value,
          invalid: false,
          parameters: [{ id: v4(), name: '', unit: '', parameterId: null, unitId: null }],
        })
      }
      return newAr
    })
  }

  const handleAddTypes = (id: number | string) => {
    setOperations((prev: IOperation[]) => {
      const newAr = [...prev]
      const objIndex = newAr.findIndex((obj) => obj.id === id)

      newAr[objIndex].parameters.push({
        id: v4(),
        invalid: false,
        name: '',
        unit: '',
        parameterId: null,
        unitId: null,
        newField: true,
      })
      return newAr
    })
  }

  const handleParamUnit = (
    value: ISelectValue,
    itemId: string | number,
    paramId: number | string,
    name: string,
  ) => {
    setOperations((prev: IOperation[]) => {
      const copy = [...prev]
      const objIndex = copy.findIndex((item: IOperation) => item.id === itemId)
      const paramIndex = copy[objIndex].parameters.findIndex(
        (item: IOperationParameter) => item.id == paramId,
      )

      if (name == 'parameter') {
        copy[objIndex].parameters[paramIndex].parameterId = value.value
        if (!Number.isInteger(copy[objIndex].parameters[paramIndex].id)) {
          copy[objIndex].parameters[paramIndex].id = value.value
        }
      } else {
        copy[objIndex].parameters[paramIndex].unitId = value.value
      }

      copy[objIndex].parameters[paramIndex][name == 'parameter' ? 'name' : 'unit'] = value.label
      if (name == 'parameter') {
        copy[objIndex].parameters[paramIndex].unitId = null
        copy[objIndex].parameters[paramIndex].unit = null
      }
      return copy
    })
  }

  const handleSelectList = (itemId: number | string, paramId: number | string) => {
    const typesIndex = operations.findIndex((item: IOperation) => item.id === itemId)
    const parameterIndex = operations[typesIndex].parameters.findIndex(
      (item: IOperationParameter) => item.id == paramId,
    )
    const name = operations[typesIndex].parameters[parameterIndex].name
    const foundValues = fetchedParameters.find((item) => item.name == name)
    // @ts-ignore
    return foundValues ? foundValues.units.map((item: IParameters) => ({ label: item.name, value: item.id }))
      : []
  }

  const handleDuplicate = (item: IOperation) => {
    const newItem = {
      ...item,
      id: v4(),
      parameters: item.parameters.map((param) => ({ ...param, id: param.parameterId })),
    }
    setOperations((prev: IOperation[]) => [...prev, newItem])
  }

  const parametersForSelect = (item: IOperation) => {
    const selectedParameters = item.parameters.map((p) => p.parameterId)
    return fetchedParameters.filter((fp) => !selectedParameters.some((sp) => sp == fp.id))
  }


  return (
    <>
      <NavBar />
      <PageWrapper>
        <H1WithBack arrow title={'Edit ' + singleOperationGroup?.name ? singleOperationGroup?.name : ''} />
        <Flex mt='16' width='100%' between>
          <WhiteBackground animate width='30%'>
            <Flex height='100%' width='100%' column gap='1rem' >
              <Input
                type='text'
                placeholder='Enter group name...'
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  setName(e.target.value)
                  e.target.value.length < 1 ? setNameInvalid(true) : setNameInvalid(false)
                }}
                labelText='Group name'
                required
                invalid={nameInvalid ? 'true' : null}
                value={name}
              />
              <Input
                type='textarea'
                style={{ minHeight: 270 }}
                placeholder='Enter description'
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  setDescription(e.target.value)
                  e.target.value.length < 1 ? setDescInvalid(true) : setDescInvalid(false)
                }}
                nomarg
                labelText={'Operation Description'}
                value={description}
                invalid={descInvalid ? 'true' : null}
              />
            </Flex>
          </WhiteBackground>
          <div style={{ width: '65%' }}>
            {operations.map((item: IOperation) => {
              return (
                <WhiteBackground key={item.id ? item.id : 1} animate mb='25px'>
                  <Flex>
                    <Input
                      placeholder='Operation name...'
                      value={item.name}
                      labelText='Operation'
                      required
                      type='text'
                      width='42%'
                      nomarg
                      name={item.id}
                      onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                        inputChange(e)
                        checkTypeValid(e)
                      }}
                      invalid={item.invalid ? 'true' : null}
                    />
                    <Flex width='40%' column>
                      {item &&
                        item.parameters.map((param) => {
                          return (
                            <Flex
                              m='0 1rem'
                              mb='16'
                              gap='1rem'
                              width='fit-content'
                              key={param.id ? param.id : 1}
                            >
                              <HonestSelectInput
                                labelText={item.parameters.indexOf(param) < 1 && 'Parameter'}
                                defaultValue={param.parameterId}
                                width='15em'
                                nomarg
                                onChange={(value: ISelectValue) =>
                                  handleParamUnit(value, item.id, param.id, 'parameter')
                                }
                                options={parametersForSelect(item)}
                                api
                                name='parameter'
                                optionsForDefault={fetchedParameters}
                              />

                              {handleSelectList(item.id, param.id).length > 0 && (
                                <HonestSelectInput
                                  labelText={item.parameters.indexOf(param) < 1 && 'Unit'}
                                  defaultValue={param.unitId}
                                  width='10em'
                                  nomarg
                                  onChange={(value: ISelectValue) =>
                                    handleParamUnit(value, item.id, param.id, 'unit')
                                  }
                                  options={handleSelectList(item.id, param.id)}
                                  name='unit'
                                />
                              )}

                              <CursorPointer
                                start='true'
                                mt={item.parameters.indexOf(param) < 1 && '15px'}
                                onClick={() => handleRemoveParameters(item.id, param.id)}
                                invisible={!(item.parameters.length > 1)}
                                width='7em'
                              >
                                <RemoveCircle />
                              </CursorPointer>
                            </Flex>
                          )
                        })}
                      <CursorPointer
                        start='true'
                        onClick={() => handleAddTypes(item.id)}
                        ml='1rem'
                        mt='5px'
                      >
                        <AddCircle />
                      </CursorPointer>
                    </Flex>

                    {operations.length > 1 && (
                      <BlackCircle
                        absolute
                        top='10px'
                        right='10px'
                        onClick={() => {
                          setOperations((prev: IOperation[]) =>
                            prev.filter((i) => i.id !== item.id),
                          )
                        }}
                      >
                        <RemoveCircle white />
                      </BlackCircle>
                    )}
                  </Flex>
                  <Duplicate onClick={() => handleDuplicate(item)}>{DuplicateIcon}</Duplicate>
                </WhiteBackground>
              )
            })}
            <AddButton
              width='42%'
              height='40px'
              orange
              onClick={() => {
                setOperations((prev: IOperation[]) => [
                  ...prev,
                  {
                    id: v4(),
                    name: '',
                    parameters: [{ id: v4(), name: 'Time', unit: 'min', unitId: 0 }],
                  },
                ])
              }}
            >
              <AddCircle white />
              Add new type
            </AddButton>
          </div>
        </Flex>
      </PageWrapper>
      <PageFooter>
        <Flex width='100%' end='true'>
          <CancelBtn />
          <Button ml='15' height='40' orange onClick={handleSubmit}>
            Update
          </Button>
        </Flex>
      </PageFooter>
    </>
  )
}
